import script from "./BaseResizeBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseResizeBar.vue?vue&type=script&lang=ts&setup=true"

import "./BaseResizeBar.vue?vue&type=style&index=0&id=74918899&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74918899"]])

export default __exports__